import React, { useEffect, useState } from 'react';
import { Form } from './forms/form';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import CircularProgressBar from './CircularProgressBar';
import Grid from '@mui/material/Grid';
import Tooltip from '@mui/material/Tooltip';
import { COLORS } from '../../styles/theme';
import { JsonFormsCore, createAjv } from '@jsonforms/core';

import partnerSchema from './forms/schemas/partner/schema.json';
import partnerUiSchema from './forms/schemas/partner/uischema.json';

const handleAjv = createAjv();
const validateRequiredAny: any = (schema: any, data: any) => {
  let isValid = true;
  let msg = '';
  if (!data.notApplicable && !data.userName) {
    isValid = false;
    msg = '   ';
  }
  validateRequiredAny.errors = [
    {
      keyword: 'validateRequiredAny',
      message: msg,
      params: { keyword: 'validateRequiredAny' },
    },
  ];
  return isValid;
};
handleAjv.addKeyword({
  validate: validateRequiredAny,
  errors: true,
  keyword: 'validateRequiredAny',
});

const StyledButtonPrimary = styled(Button)(() => ({
  color: COLORS.WHITE,
  backgroundColor: COLORS.PRIMARY_BLUE,
  minWidth: '90px',
  '&:hover': {
    backgroundColor: COLORS.PRIMARY_BLUE,
  },
}));

const StyledContent = styled('div')(() => ({
  '& .MuiFormControlLabel-root': {
    display: 'flex',
    justifyContent: 'flex-end',
    marginRight: '0px',
    '& .MuiCheckbox-root': {
      padding: '1px 3px 3px',
    },
    '& .MuiFormControlLabel-label': {
      fontSize: '15px',
    },
  },
}));

export interface PartnerInfoControlProps {
  onChange?(state: Pick<JsonFormsCore, 'data' | 'errors'>): void;
  profileData?: any;
  onProfileChanged?: (clientUserName: string) => Promise<boolean>;
  locationKey?: string;
}

export const PartnerInfoControl = ({
  onChange,
  onProfileChanged,
  profileData,
  locationKey,
}: PartnerInfoControlProps) => {
  const [props, setProps] = useState<any>(profileData);
  const [isvalid, setIsvalid] = useState<boolean>(false);
  const [formSubmitted, setFormSubmitted] = useState<boolean>(false);
  const [showProgress, setShowProgress] = useState<boolean>(false);
  const [currentLocationKey] = useState<string | undefined>(locationKey);

  useEffect(() => {
    if (currentLocationKey !== locationKey) {
      setProps(profileData);
    }
  }, [currentLocationKey, profileData, locationKey]);

  const onChangeCheckbox = (event: any) => {
    setFormSubmitted(false);
    if (event.target.type === 'checkbox') {
      setFormSubmitted(true);
    }
  };

  const _handleChange = (state: Pick<JsonFormsCore, 'data' | 'errors'>) => {
    let valid = true;
    if (state && state.errors && state.errors.length) {
      valid = false;
      document.addEventListener('change', onChangeCheckbox);
    }
    if (state.data) {
      setProps(state.data);
    }
    if (onChange) {
      onChange(state);
    }
    setIsvalid(valid);
  };

  const saveProfile = async () => {
    setFormSubmitted(true);
    if (props && props.clientPlatform && isvalid && onProfileChanged) {
      setShowProgress(true);
      await onProfileChanged(props.clientPlatform);
      setShowProgress(false);
      setFormSubmitted(false);
    }
  };

  const onKeyPress = (event: any) => {
    if (event.key === 'Enter') {
      saveProfile();
    }
  };

  return (
    // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
    <form onKeyUp={onKeyPress}>
      <div
        className={`${formSubmitted ? 'formSubmitted' : ''} ${
          isvalid ? 'isvalid' : 'notvalid'
        }`}
      >
        <Grid container justifyContent="flex-start" spacing={1}>
          <Grid item sm={7}>
            <StyledContent>
              <Form
                onChange={_handleChange}
                data={props}
                uischema={partnerUiSchema}
                schema={partnerSchema}
                ajv={handleAjv}
              />
            </StyledContent>
          </Grid>
          <Grid item sm={9}>
            <div style={{ textAlign: 'right' }}>
              <Tooltip
                title={
                  !isvalid
                    ? 'User Name or Not Applicable option is required'
                    : ''
                }
                arrow
                placement="top"
              >
                <span>
                  <StyledButtonPrimary
                    variant="contained"
                    data-testid="saveProfileButton"
                    disabled={!isvalid}
                    onClick={saveProfile}
                  >
                    Save
                    {showProgress && (
                      <div className="MuiProgressOverlay">
                        <CircularProgressBar />
                      </div>
                    )}
                  </StyledButtonPrimary>
                </span>
              </Tooltip>
            </div>
          </Grid>
        </Grid>
      </div>
    </form>
  );
};
